import { Icon } from "@iconify/react";
import React from "react";
import { NavLink } from "react-router-dom";
import history from "../../assets/icons/history.svg";
const Sidebar = () => {
  return (
    <>
      <div className="sidebar dark-russian">
        <div className="top d-flex align-items-center gap-3">
          <img src="/favicon1.png" alt="" />
          <h5>Blueprint.</h5>
        </div>
        <div className="bottom">
          <NavLink to="/" className="list d-flex align-items-center gap-3">
            <Icon
              icon="ion:home"
              width="30"
              height="30"
              style={{ color: "white" }}
            />
            <h5 className="fw-normal">Home</h5>
          </NavLink>
          <NavLink
            to="/history"
            className="list d-flex align-items-center gap-3"
          >
            <img src={history} alt="" />
            <h5 className="fw-normal">History</h5>
          </NavLink>
        </div>
        <div>
          <div className="setting">
            <NavLink
              to="/settings"
              className="list d-flex align-items-center gap-3"
            >
              <Icon
                icon="icon-park-solid:setting"
                width="30"
                height="30"
                style={{ color: "white" }}
              />
              <h5 className="fw-normal">Settings</h5>
            </NavLink>
            <div className="list d-flex align-items-center gap-3">
              <Icon
                icon="majesticons:logout"
                width="30"
                height="30"
                style={{ color: "white" }}
              />
              <h5 className="fw-normal">Log out</h5>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
